import React, { Component } from 'react';

import classNames from 'classnames';
import debounce from 'lodash/debounce';
import PropTypes from 'prop-types';

import Input from '../Input';

import './SearchInput.scss';

export default class SearchInput extends Component {
  static propTypes = {
    children: PropTypes.node,
    classIcon: PropTypes.string,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    handleKeyDown: PropTypes.func,
    hasClean: PropTypes.bool,
    icon: PropTypes.string,
    loading: PropTypes.bool,
    noborder: PropTypes.bool,
    noicon: PropTypes.bool,
    noplaceholder: PropTypes.bool,
    onChange: PropTypes.func,
    onClean: PropTypes.func,
    placeholder: PropTypes.string,
    position: PropTypes.string,
    value: PropTypes.string,
    wait: PropTypes.number
  };

  static defaultProps = {
    icon: 'search',
    placeholder: 'general.search_placeholder',
    wait: 600,
    value: ''
  };

  state = {
    value: this.props.value
  };

  constructor(props) {
    super(props);

    this.handleClean = this.handleClean.bind(this);
    this.handleKeyDown = this.handleKeyDown.bind(this);
    this.onChangeHandler = this.onChangeHandler.bind(this);
  }

  componentDidMount() {
    const { wait, onChange } = this.props;

    this.onChange = debounce(onChange, wait);
  }

  get value() {
    return this.state.value;
  }

  set value(value) {
    this.setState({ value });
  }

  cleanValue = () => {
    this.setState({ value: '' });
  };

  onChangeHandler = ({ target }) => {
    if (target) {
      const { onChange } = this.props;
      const { value } = target;

      this.setState({ value });

      onChange && this.onChange(value);
    }
  };

  handleKeyDown(event) {
    if (event.key === 'Enter') {
      this.onChangeHandler(event);
    }

    const { handleKeyDown } = this.props;

    handleKeyDown && handleKeyDown(event);
  }

  handleClean(event) {
    const { onClean } = this.props;

    event.stopPropagation();

    onClean && onClean();
  }

  get searchIcon() {
    const { classIcon = '', icon, noicon, position = 'left' } = this.props;

    return (
      !noicon && (
        <label
          htmlFor="search__input"
          key="search__input__label"
          className={`icon icon-${icon} icon--${position} ${classIcon}`}
        />
      )
    );
  }

  get cleanIcon() {
    const { hasClean } = this.props;

    return (
      hasClean &&
      this.state.value && (
        <i className="icon icon-close" onClick={this.handleClean} />
      )
    );
  }

  render() {
    const { value } = this.state;
    const {
      className,
      disabled,
      icon,
      loading,
      noborder,
      noicon,
      noplaceholder,
      placeholder,
      position = 'left',
      children,
      hasClean: _hasClean,
      onClean: _onClean,
      ...props
    } = this.props;

    const searchIconClass = `search__input__icon--${position}`;

    const classContainer = classNames('search__input__container', {
      'search__input__container--disabled': disabled
    });

    const classComponent = classNames(
      'search__input',
      'o-form-input',
      { 'search__input--noborder': noborder },
      { [searchIconClass]: !noicon && icon },
      className
    );

    return (
      <div className={classContainer}>
        {this.searchIcon}

        {this.cleanIcon}

        {loading && <i className="icon icon-processing" />}

        <Input
          {...props}
          className={classComponent}
          disabled={disabled}
          id="search__input"
          key="search__input"
          name="search__input"
          onChange={this.onChangeHandler}
          handleKeyDown={this.handleKeyDown}
          placeholder={!noplaceholder && placeholder}
          type="text"
          value={value}
        />

        {children}
      </div>
    );
  }
}
